import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { type NodeKey } from 'lexical'
import { BaseNode, SerializedBaseNode } from './BaseNode'

export class TransitionNode extends BaseNode {
    next = NodeType.Scene
    enableSuggestions = true
    suggestionPlacement = 'bottom-end'

    static getType(): string {
        return 'transition'
    }

    static clone(node: TransitionNode): TransitionNode {
        return new TransitionNode(node.id, node.__key)
    }

    constructor(id: string, key?: NodeKey) {
        super(id, key)
    }

    createHtmlElement(): HTMLElement {
        const dom = document.createElement('div')
        dom.className = 'transition-node node-style-common avoid-page-break'
        return dom
    }

    static importJSON(jsonNode: SerializedBaseNode): TransitionNode {
        return new TransitionNode(jsonNode.id)
    }

    static importDOM(): null {
        return null
    }
}
